'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlProgressBar", function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      progress: "=position"
    },
    template: '' + '<div class="tl-progress-bar">' + '<div class="caption">{{progress | number}} %</div>' + '<div class="progress" ng-style="{ width: progress + \'%\'}"></div>' + '</div>'
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/tl/tl-progress-bar.js
// module id = 2897
// module chunks = 13